import React from 'react'
import { Button } from 'components/buttons'
import { localized } from 'decorators'
import { Icon } from 'components/icons'
import { useStyles } from './errorViewer.css'

export const ErrorViewer = props => {
  const classes = useStyles()
  const { localize, onClick } = props
  return (
    <div className={classes.root}>
      <h5>{props.error || localize('common.errorOccurred')}</h5>
      <Button color='secondary' onClick={onClick} width={200}><Icon name='refresh' /> &nbsp;&nbsp;{localize('common.tryAgain')}</Button>
    </div>
  )
}

export default localized(ErrorViewer)
